module.exports = __webpack_public_path__ + "static/img/profile-target-1.1d5d5e34.png";